import type { ReactNode } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

/** The panel's width in px, which the steps leave clear while it is open. */
export const SIDE_PANEL_WIDTH = 380;
/** The same width as right padding, for a scrolling view to keep its content clear of the panel. */
export const SIDE_PANEL_CLEARANCE = 'pr-[380px]';

/** A panel over the right side of the steps: the test run. */
export const SidePanel = ({ label, onClose, children }: { label: string; onClose: () => void; children: ReactNode }) => (
	<aside
		aria-label={label}
		className='absolute inset-y-0 right-0 z-10 flex w-[380px] flex-col border-l border-gray-500 bg-white shadow-[-12px_0_32px_-16px_rgba(16,24,40,0.18)]'
	>
		<Button variant='ghost' size='icon-sm' aria-label='Close' className='absolute top-2.5 right-2.5 z-10' onClick={onClose}>
			<X className='size-4' />
		</Button>
		<div className='min-h-0 flex-1 overflow-y-auto'>{children}</div>
	</aside>
);
